exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#addProjectedReceiverModal .v--modal-box.v--modal{min-height:285px!important;min-width:820px!important}#addProjectedReceiverModal :not(.v-icon){font-size:12px}#addProjectedReceiverModal .icon{margin-right:10px;margin-left:10px}#addProjectedReceiverModal .button__wrapper{padding-top:5px;padding-bottom:5px}.row__border--bottom{border-bottom:1px solid #d3d3d3}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-de25e44a","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/viewer/modelWat/modals/AddProjectedReceiver.vue
// module id = 1824
// module chunks = 0